<template>
  <AppSection id="profile" :is-section-loading="newEmailLoading" :title="$getConst.pages.profile.email" type="page">

    <b-row>
      <b-col lg="6">
        <b-form-group id="current-email" :label="$t(this.$getConst.pages.profile.current_email)+':'" label-for="current-email-input">
          <b-form-input
            id="current-email-input"
            plaintext
            :value="$store.getters['auth/userEmail']"
            size="lg"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col lg="6">
        <b-form-group id="email" :label="(emailWaiting ? $t(this.$getConst.pages.profile.email_to_confirm) : $t(this.$getConst.pages.profile.new_email))+':'" label-for="email-input">
          <b-form-input
            id="email-input"
            @input="initInputEmail"
            v-model.trim="$v.newEmail.$model"
            :disabled="!!emailWaiting"
            :class="{ 'is-invalid': $v.newEmail.$error || emailError }"
            :placeholder="$t(this.$getConst.pages.profile.enter_email)"
            size="lg"
            required
          ></b-form-input>
          <template v-if="!!emailWaiting">
            <a
              type="button"
              @click="confirmRemoveEmail"
              :class="{'disabled': $store.getters['auth/isLoggedAs']}"
              class="float-right text-danger ml-1"
            >
              {{$t(this.$getConst.pages.button.remove)}}
            </a>

            <a
              type="button"
              @click="openVerificationCodeModal"
              :class="{'disabled': $store.getters['auth/isLoggedAs']}"
              class="float-right text-success"
            >
              {{$t(this.$getConst.pages.profile.enter_email_verification_code)}}
            </a>
          </template>
          <AppFormFeedback :errors="$v.newEmail" :emailError="emailError"/>
          <b-form-invalid-feedback v-if="!!emailWaiting">
            {{$t(this.$getConst.pages.profile.remove_new_email_error)}}.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

    </b-row>

    <AppConfirmButtons
      :submit-text="$getConst.pages.button.save"
      no-cancel
      :first-button="!emailWaiting"
      :second-button="!!emailWaiting"
      :second-button-text="$getConst.pages.profile.resend_email"
      :is-disabled="newEmail === $store.getters['auth/userEmail']|| !!emailWaiting || $v.newEmail.$invalid || !newEmail || $store.getters['auth/isLoggedAs']"
      :is-loading="resendLoading"
      @onSubmit="confirmChangeEmail"
      @onSecondSubmit="resendVerificationCode"
    />

    <AppConfirmationModal
      id="change-email-confirmation"
      :title="$t(this.$getConst.pages.profile.are_you_sure)"
      :message=$t(this.$getConst.pages.profile.confirm_change_email_message) | capitalize
      :is-loading="changeLoading"
      ref="confirmChangeEmail"
      @onConfirm="changeEmail"/>

    <AppConfirmationModal
      id="remove-email-confirmation"
      :title="$t(this.$getConst.pages.profile.are_you_sure)"
      :message=$t(this.$getConst.pages.profile.confirm_remove_email_message) | capitalize
      :is-loading="removeLoading"
      ref="confirmRemoveEmail"
      @onConfirm="removeNewEmail"/>

    <VerificationCodeModal @verifyCode="verifyCode"></VerificationCodeModal>


  </AppSection>
</template>
<script>
  import {changeEmail, getNewEmailIfExist, removeNewEmail, resendVerificationCode} from "../../../api/userEmail.api";
  import { email } from 'vuelidate/lib/validators';
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  import AppConfirmationModal from "../../../components/common/modals/AppConfirmationModal";
  import AppSection from "../../../components/common/sections/AppSection";
  import VerificationCodeModal from "./VerificationCodeModal";

  export default {
    name: 'EditEmail',
    components: {VerificationCodeModal, AppSection, AppConfirmationModal, AppConfirmButtons, AppFormFeedback},
    data() {
      return {
        newEmail: null,
        emailWaiting: null,
        resendLoading: false,
        removeLoading: false,
        changeLoading: false,
        newEmailLoading: false,
        emailError:null
      }
    },
    validations: {
      newEmail: {email},
    },
    created() {
      this.newEmailLoading = true;
      getNewEmailIfExist().then(
        res => {
          this.newEmail = res.data;
          this.emailWaiting = res.data;
          this.newEmailLoading = false;
        },
        (error) => {
          this.handleApiError(error);
          this.newEmailLoading = false;
        }
      )
    },
    methods: {
      initInputEmail(){
        this.emailError = null;
      },
      confirmChangeEmail() {
        this.$bvModal.show('change-email-confirmation');
      },
      confirmRemoveEmail() {
        this.$bvModal.show('remove-email-confirmation');
      },
      changeEmail() {
        this.changeLoading = true;
        changeEmail(this.newEmail)
          .then(() => {
            this.emailWaiting = this.newEmail;
            this.$refs.confirmChangeEmail.close();
            this.$snotify.success(
              this.$t(this.$getConst.pages.profile.success_change_email_message),
              this.$t(this.$getConst.pages.profile.changed)
            );
            this.changeLoading = false;
          })
          .catch(error => {
            if (error.response.data.code === 422 || error.response.data.code === 409){
              this.emailError = "Invalid Email";
            }
            this.$refs.confirmChangeEmail.close();
            this.handleApiError(error);
            this.changeLoading = false;
          })
      },
      removeNewEmail() {
        this.removeLoading = true;
        removeNewEmail()
          .then(() => {
            this.newEmail = null;
            this.emailWaiting = null;
            this.$refs.confirmRemoveEmail.close();
            this.$snotify.success(
              this.$t(this.$getConst.pages.profile.success_remove_email_message),
              this.$t(this.$getConst.pages.profile.success)
            );
            this.removeLoading = false;
          })
          .catch(error => {
            this.$refs.confirmRemoveEmail.close();
            this.handleApiError(error);
            this.removeLoading = false;
          })
      },
      resendVerificationCode() {
        this.resendLoading = true;
        resendVerificationCode().then(
          () => {
            this.resendLoading = false;
            this.$snotify.success(
              this.$t(this.$getConst.pages.profile.success_resend_code_message),
              this.$t(this.$getConst.pages.profile.success)
            );
          },
          (error) => {
            this.resendLoading = false;
            this.handleApiError(error);
          }
        )
      },
      openVerificationCodeModal() {
        this.$bvModal.show('verification-code-modal');
      },
      verifyCode() {
        this.$store.dispatch("auth/updateUserEmail", this.newEmail);
        this.newEmail = '';
        this.emailWaiting = false;
      }
    }
  }
</script>
